import { render, staticRenderFns } from "./MonsterSkills.vue?vue&type=template&id=521ea754&scoped=true&"
import script from "./MonsterSkills.vue?vue&type=script&lang=ts&"
export * from "./MonsterSkills.vue?vue&type=script&lang=ts&"
import style0 from "./MonsterSkills.vue?vue&type=style&index=0&id=521ea754&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521ea754",
  null
  
)

export default component.exports